





























import Vue from 'vue'
import {fieldProps} from '../BZCore/ActiveField'
import Errors from '../errors.vue'
import UiSelectInput from '../../Inputs/SelectInput.vue'


export default Vue.extend({
  name: 'DateTimeRangeField',
  props: fieldProps,
  components: {Errors, UiSelectInput},
  methods: {
    onInput (event: any) {
      this.$emit('input', event)
    },
  },
  computed: {
    currentValue: {
      get (): any {
        return this.value
      },
      set () {

      }
    }
  }
})
